import React from "react"
import { ToastContainer } from "react-toastify"

import Routes from "./routes"
import AppProvider from "./hooks/index"
import Modal from "./components/PhotoModal"
import Helper from "./components/Helper"
import LoadingModal from "components/LoadingModal"
import DisconnectedModal from "components/DisconnectedModal"
import { ErrorBoundary } from "react-error-boundary"
import ErrorPage from "pages/ErrorPage"
import { ProjectMetadataDisplay } from "components/ProjectMetaDataDisplay"

const onErrorBoundary = (err) => {
  console.error("%cErrorBoundary caught this error:\n", "color: orange", err)
}
const App = () => {
  return (
    <AppProvider>
      <Modal />
      <LoadingModal />
      <DisconnectedModal />
      <Helper />
      <ToastContainer autoClose={3000} />
      <ErrorBoundary onError={onErrorBoundary} FallbackComponent={ErrorPage}>
        <Routes />
      </ErrorBoundary>
      <ProjectMetadataDisplay />
    </AppProvider>
  )
}

export default App
